import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ClinicForm } from '@models/forms/clinic-form';
import { formTypeNames } from '@models/forms/form-type.enum';
import { FormType } from '@models/forms/form-type.enum';
import { User } from '@models/user';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClinicsService } from '@services/clinics.service';
import { SharedFormService } from '@services/shared-form.service';
import { UsersService } from '@services/users.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-share-form',
  templateUrl: './share-form.component.html',
  styleUrls: ['./share-form.component.less'],
})
export class ShareFormComponent implements OnInit, OnDestroy {
  @Input() formToShare: ClinicForm;
  form: FormGroup;
  unsub: Subject<void> = new Subject<void>();
  loading = false;
  formTypes: FormType[] = [];
  FormType = FormType;
  formTypeNames = formTypeNames;

  loggedInUser: User;
  loggedInUserFullName: string;
  loggedInClinicName: string;

  constructor(
    public activeModal: NgbActiveModal,
    private sharedFormService: SharedFormService,
    private userService: UsersService,
    private clinicService: ClinicsService
  ) {
    this.loggedInUser = this.userService.loggedInUser;
    this.loggedInUserFullName = `${this.loggedInUser.firstName} ${this.loggedInUser.lastName}`;

    this.clinicService
      .getClinicById(this.loggedInUser.clinicId)
      .pipe(takeUntil(this.unsub))
      .subscribe((clinic) => {
        this.loggedInClinicName = clinic.name;
      });
  }

  ngOnInit() {
    this.initForm();
    this.setFormValues();
  }

  private initForm() {
    this.form = new FormGroup({
      id: new FormControl(0, [Validators.required]),
      name: new FormControl('', [Validators.required]),
      notes: new FormControl(),
      formType: new FormControl(null, [Validators.required]),
      formDefinition: new FormControl(''),
      sharedByUserId: new FormControl(''),
      sharedByClinicId: new FormControl(0),
    });
  }

  private setFormValues() {
    if (this.formToShare !== null && this.formToShare !== undefined) {
      this.form.controls['id'].setValue(0);
      this.form.controls['formType'].setValue(this.FormType[this.formToShare.formType]);
      this.form.controls['name'].setValue(this.formToShare.name);
      this.form.controls['notes'].setValue(this.formToShare.notes);
      this.form.controls['formDefinition'].setValue(this.formToShare.formDefinition);
      this.form.controls['sharedByUserId'].setValue(this.loggedInUser.id);
      this.form.controls['sharedByClinicId'].setValue(this.loggedInUser.clinicId);
    } else {
      console.log('Form not shared to Share modal.');
    }
  }

  onSubmit() {
    this.loading = true;
    try {
      this.sharedFormService
        .addSharedForm(this.form.value)
        .pipe(takeUntil(this.unsub))
        .subscribe(() => {
          this.loading = false;
          this.activeModal.dismiss();
        });
    } catch (e) {
      this.loading = false;
    }
  }

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}
